import React from 'react';
import HelpContent from './HelpContent';
import HidrogenoCamiones from 'img/camion_hidrogeno.png';

const ReemplazoTransporteCargaHelp = () => (
  <HelpContent>
    <h1>Reemplazo de tecnologías en camiones de transporte de carga</h1>
    <p>
    Esta medida considera un conjunto de submedidas aplicadas a transporte de carga. 
    Se contempla una medida regulatoria de estándar de rendimiento, uso de diésel renovable en transporte de carga de larga distancia y 
    electromovilidad en camiones livianos y medianos.
    </p>
    <p>
    La medida de estándar de rendimiento energético para vehículos pesados aplica a camiones livianos, medianos y tractocamiones. 
    Se modela como un estándar de ventas de vehículos cero emisiones, donde se espera que el hidrógeno tome protagonismo. 
    Además, para transporte de larga distancia (tractocamiones), se considera la medida de uso de diésel renovable en reemplazo directo del diésel convencional. 
    En paralelo y en base a la evidencia de los últimos años, se tiene el ingreso de camiones eléctricos en el mercado permitiendo la electromovilidad en camiones livianos y medianos.
    </p>

	<img src={HidrogenoCamiones} alt="Hidrógeno en transporte de carga"/>
    <label>Figura: Estación de carga de camiones de hidrógeno. Fuente: Nikola Motor https://nikolamotor.com/energy  </label>
    
    <p>
      <strong>Trayectoria 1:</strong>
    </p>
    <p>
      Estándar de rendimiento: tanto para tractocamiones como para camiones livianos y medianos se considera el ingreso de hidrógeno con participación 
      de 1,0% al año 2040 aumentando hasta 44,2% en 2050.
    </p>
    <p>
      Diésel renovable: la participación de diésel renovable en tractocamiones en de 1% en 2035 alcanzando un 10% en 2050.
    </p>
    <p>
      Electromovilidad: la participación de camiones eléctricos es de 20% en 2030, 30% en 2040 y 50% en 2050.
    </p>
  </HelpContent>
);

export default ReemplazoTransporteCargaHelp;
